import axios from 'axios';

const api = axios.create({
  baseURL: 'https://www.api.goonflow.com/',
});

export default api;
